import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, Settings, CreditCard, LogOut, Download, Users } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a72ee028-442b-44ea-ad3d-be1abd62a5cf/artifacts/zdjtc3rc_Logo_Falo_com_o_dono-removebg-preview.png";

export const OwnerSidebar = ({ user, mobile, setSidebarOpen, handleLogout, activePage, companySelector }) => {
  const close = () => mobile && setSidebarOpen(false);

  return (
    <div className={`flex flex-col h-full ${mobile ? '' : 'fixed left-0 top-0 h-screen w-64'}`}>
      <div className="p-5 border-b border-white/10">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Falo Com O Dono" className="h-20 w-auto object-contain" />
          <div>
            <span className="font-semibold text-white text-sm">Falo Com O Dono</span>
            <p className="text-xs text-slate-400">Painel do Dono</p>
          </div>
        </div>
        {companySelector && <div className="mt-3">{companySelector}</div>}
      </div>
      <nav className="flex-1 p-4 space-y-1">
        <p className="text-xs font-medium text-slate-500 uppercase tracking-wider px-4 mb-3">Menu</p>
        <Link to="/dashboard" className={`sidebar-link ${activePage === 'dashboard' ? 'sidebar-link-active' : ''}`} onClick={close}>
          <Home className="w-5 h-5" />Painel do Dono
        </Link>
        <Link to="/settings" className={`sidebar-link ${activePage === 'settings' ? 'sidebar-link-active' : ''}`} onClick={close} id="sidebar-settings">
          <Settings className="w-5 h-5" />Configuracoes
        </Link>
        <Link to="/plans" className={`sidebar-link ${activePage === 'plans' ? 'sidebar-link-active' : ''}`} onClick={close}>
          <CreditCard className="w-5 h-5" />Gerenciar Plano
        </Link>
        <Link to="/settings?tab=qrcode" className="sidebar-link" onClick={close} id="sidebar-materials">
          <Download className="w-5 h-5" />Materiais de Venda
        </Link>
      </nav>
      <div className="p-4 border-t border-white/10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
            <Users className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-white truncate">{user?.name}</p>
            <p className="text-xs text-slate-400 truncate">{user?.company_name}</p>
          </div>
        </div>
        <Button variant="ghost" className="w-full justify-start text-slate-400 hover:text-white hover:bg-white/10 text-sm" onClick={handleLogout} data-testid="logout-btn">
          <LogOut className="w-4 h-4 mr-2" />Sair da conta
        </Button>
      </div>
    </div>
  );
};
